class SearchForm extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.trackOverlayClicks = this.trackOverlayClicks.bind(this)
  }

  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  static get requiredElements () {
    return ['input']
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onBodyClick = this.onBodyClick.bind(this)
    this.handleMobileNavTrigger = this.handleMobileNavTrigger.bind(this)

    this.listeners.add(this.els.input.element, 'click', this.onTriggerClick)
    this.listeners.add(document.body, 'click', this.onBodyClick)

    if (this.els?.cancel?.element) {
      this.onCancelClick = this.onCancelClick.bind(this)

      this.listeners.add(this.els.cancel.element, 'click', this.onCancelClick)
    }

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.MOBILE_MENU.RENDERED,
      this.handleMobileNavTrigger,
    )
  }

  handleMobileNavTrigger () {
    const mobileTrigger = this.externalEls['mobile-search-trigger'].element

    if (!mobileTrigger) return

    mobileTrigger.addEventListener('click', e => {
      e.stopImmediatePropagation()

      const drawerBackdrop = document.querySelector(
        '[data-site-drawers-el="backdrop"]',
      )

      drawerBackdrop.click()

      const inputId = window.BAO.MediaBreakpoints.isSm
        ? '#header-search'
        : '#mobile-header-search'
      const activeSearchInput = document.querySelector(
        `${this.els.input.selector}${inputId}`,
      )

      if (!activeSearchInput) return

      activeSearchInput.click()
      activeSearchInput.focus()

      if (!this.isActive) {
        this.trackOverlayOpens('drawer')
      }
    })
  }

  onTriggerClick (event) {
    if (!this.isActive) {
      this.trackOverlayOpens('header')
    }

    this.isActive = true

    this.watchForOverlay()
  }

  onCancelClick () {
    this.isActive = false
    this.els.input.element.value = ''
    this.removeOverlayListeners()
  }

  onBodyClick (event) {
    if (
      event.target.closest('.hd-Banner_SearchField') ||
      event.target.closest('.kuPreventDocumentClick')
    ) {
      return
    }
    if (!this.isActive) return

    this.isActive = false
    this.removeOverlayListeners()
  }

  watchForOverlay () {
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('.klevuWrap')) {
              this.setupOverlayListeners()
            }
          }
        }
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }

  setupOverlayListeners () {
    const searchOverlayWrapper = document.querySelector('.klevuWrap')

    if (!searchOverlayWrapper) return

    searchOverlayWrapper.addEventListener('click', this.trackOverlayClicks)
  }

  removeOverlayListeners () {
    const searchOverlayWrapper = document.querySelector('.klevuWrap')

    if (!searchOverlayWrapper) return

    searchOverlayWrapper.removeEventListener('click', this.trackOverlayClicks)
  }

  trackOverlayOpens (placement) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'search_overlay_open',
      target_context: placement,
    })
  }

  trackOverlayClicks (event) {
    const eventTarget = event.target
    const eventContext = eventTarget.closest('[data-ga4-target-context]')

    if (!eventContext) return

    const searchTerm =
      [...document.querySelectorAll('[data-search-form-el="input"]')]
        .find(el => el.value?.trim())
        ?.value.trim() ?? ''

    const targetContext = eventContext
      .getAttribute('data-ga4-target-context')
      .replace('search-overlay-', '')

    const dataLayer = window.dataLayer || []

    dataLayer.push({
      event: 'search_overlay_click',
      target_context: targetContext,
      target_url: eventTarget.href,
      event_context: searchTerm,
    })
  }

  get isActive () {
    return this.hasAttribute('active')
  }

  set isActive (val) {
    val ? this.setAttribute('active', '') : this.removeAttribute('active')

    document.body.classList.toggle('util-SiteOverflowed', val)
    document.body.classList.toggle('util-KlevuActive', val)
    document.body.classList.toggle('util-HideChat', val)
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm)
}
